import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=1af82547&scoped=true&"
import script from "./activation.vue?vue&type=script&lang=js&"
export * from "./activation.vue?vue&type=script&lang=js&"
import style0 from "./activation.vue?vue&type=style&index=0&id=1af82547&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af82547",
  null
  
)

export default component.exports